const products = [
    {
        id: "1",
        img: "/Images/Ourteam/team/31.jpg",
        Sname:"HARISH SHET",
        Sdesignation:"Project Lead"
    },
    {
        id: "2",
        img: "/Images/Ourteam/team/12.jpg",
         Sname:"SHRISTI KARWASARA",
        Sdesignation:"Support Team Lead"
    },
    {
        id: "3",
        img: "/Images/Ourteam/team/2.jpg",
         Sname:"ASTHA BHAMBU",
        Sdesignation:"Senior Implementation Engineer"
    },
    {
        id: "5",
        img: "/Images/Ourteam/team/16.jpg",
         Sname:"MEHUL SHARMA",
        Sdesignation:"Implementation Engineer"
    },
    {
        id: "6",
        img: "/Images/Ourteam/team/20.jpg",
         Sname:"AKASH MISHRA",
        Sdesignation:"Technical Support Executive"
    }
]

export default products